// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;Look upon him and be radiant&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and your faces shall not be ashamed.<br> </p> </div></div>";
// Exports
module.exports = code;